import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { RestApiProvider } from '../../providers/rest-api/rest-api';
import { EditscontiPage } from '../../pages/editsconti/editsconti';

/**
 * Generated class for the ScontiPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-sconti',
  templateUrl: 'sconti.html',
})
export class ScontiPage {
  errorMessage;
  orario
  constructor(public navCtrl: NavController, public navParams: NavParams,
    public rest: RestApiProvider,

    ) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ScontiPage');
    this.getOrario();
  }
  getOrario() {
    this.rest.getTimeStoreInfo().subscribe(
      orario => {
        this.orario = orario; //orario contiene info sconti
        

       //   alert(JSON.stringify(orario));

      },
      error => this.errorMessage = <any>error);
  }
  openEditscontiPage(){
    this.navCtrl.push(EditscontiPage, { orario: this.orario });

  }
}



// WEBPACK FOOTER //
// ./src/pages/sconti/sconti.ts